import { atom } from 'recoil';

export const jobStatusData = atom({
  key: "jobStatusData",
  default: []
});